import React from 'react';
import { Grid } from '@mui/material';
import { ProcedureProduct } from 'types/procedure';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';

interface ProcedureProductsListProps {
  products: ProcedureProduct[];
  handleDeleteProduct(product: ProcedureProduct, index: number): void;
  handleEditProduct(product: ProcedureProduct, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'name', label: 'Produto' },
  { id: 'quantity', label: 'Quantidade', align: 'right', width: '120px' },
];

const ProcedureProductsList: React.FC<ProcedureProductsListProps> = ({
  products,
  handleDeleteProduct,
  handleEditProduct,
}) => (
  <Grid size={12}>
    <RecordList
      columns={columns}
      rows={products.map((item, index) => ({
        key: item.id || index,
        values: {
          name: item.product?.name || 'Produto',
          quantity: `${item.quantity} ${item.product?.unit || ''}`.trim(),
        },
      }))}
      onEdit={index => handleEditProduct(products[index], index)}
      onDelete={index => handleDeleteProduct(products[index], index)}
    />
  </Grid>
);

export default ProcedureProductsList;
